import { css, errorStyle } from "./SKT";
import { createElement } from "react";
import { SKTBaseComponent } from "./SKTBaseComponent";
import { SKTToggle } from "./SKTToggle";

const SKTBaseTextField = ({
  id,
  label,
  placeholder,
  data,
  inputType,
  tooltip,
}) => {
  const onchange = (event) => {
    const value = event.target.value;
    data.set(id, value);
  };

  return (
    <SKTBaseComponent data={data} id={id} label={label} tooltip={tooltip}>
      <input
        className={css("form-control data")}
        style={errorStyle(data.isValid(id))}
        id={id}
        name={id}
        placeholder={placeholder}
        type={inputType}
        value={data.get(id)}
        onChange={onchange}
      />
    </SKTBaseComponent>
  );
};

export const SKTTextArea = ({ id, label, placeholder, data, inputType }) => {
  const onchange = (event) => {
    const value = event.target.value;
    data.set(id, value);
  };

  return (
    <SKTBaseComponent data={data} id={id} label={label}>
      <textarea
        className={css("form-control data")}
        style={errorStyle(data.isValid(id))}
        id={id}
        name={id}
        type={inputType}
        value={data.get(id)}
        onChange={onchange}
        rows={5}
        columns={80}
      />
    </SKTBaseComponent>
  );
};

export const SKTFileField = ({ id, label, data }) => {
  const onchange = (event) => {
    const value = event.target.files[0];
    const reader = new FileReader();
    reader.addEventListener("load", (loadevent) => {
      data.set(id, { name: value.name, content: loadevent.target.result });
    });
    reader.readAsDataURL(value);
  };
  return (
    <SKTBaseComponent data={data} id={id} label={label}>
      <input
        className={css("form-control data")}
        style={errorStyle(data.isValid(id))}
        id={id}
        name={id}
        type="file"
        onChange={onchange}
      />
    </SKTBaseComponent>
  );
};

export const SKTTextField = (props) => {
  return createElement(SKTBaseTextField, { ...props, inputType: "text" });
};

export const SKTPassword = (props) => {
  return createElement(SKTBaseTextField, {
    ...props,
    inputType: "password",
  });
};
